import { createSlice } from '@reduxjs/toolkit';

import { IInfrastructuresState } from './interfaces';
import { loadInfrastructuresItem, loadInfrastructuresList } from './actions';

export const infrastructuresSlice = createSlice({
  name: 'infrastructure',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
  } as IInfrastructuresState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadInfrastructuresList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadInfrastructuresItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
